import { Pipe, PipeTransform } from '@angular/core';
import { supressLeadingZeros } from '@lib-ui/lib/functions';


@Pipe({
  name: 'suppressLeadingZeros',
  standalone: true,
})
export class SuppressLeadingZerosPipe implements PipeTransform {

  transform(value: string | null | undefined, filterOut = true): string {
    return supressLeadingZeros(value, filterOut)?.toString() ?? '';
  }

}
